export function debounce(func, wait = 300, leading = false) {
  let timeout;
  return (...args) => {
    const context = this;

    const later = () => {
      timeout = null;
      if (!leading) func.apply(context, args);
    };

    const callNow = leading && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export const debounceAction = (action, wait, leading) => {
  const debounced = debounce(
    (dispatch, actionArgs) => dispatch(action(...actionArgs)),
    wait,
    leading
  );

  const thunk = (...actionArgs) => dispatch => debounced(dispatch, actionArgs);

  thunk.cancel = debounced.cancel;
  thunk.flush = debounced.flush;

  return thunk;
};
